import axios, { ResponseType } from "axios";
import * as Constants from "../constants";
import { EErrorCode } from "../enums/EErrorCode";
import { IResponse } from "../interfaces/IResponse";
import { v4 as uuidv4 } from "uuid";

const TAG = "CHttpUtil";

export class CHttpUtil {
  public static async post(subUrl: string, jsonBody: any) {
    var resp: IResponse;

    try {
      var baseURL;
      if (process.env.NODE_ENV === "development") {
        //baseURL = "https://localhost/";
      }


      const response = await axios.post(subUrl, JSON.stringify(jsonBody), {
        baseURL: baseURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-MB-Timestamp": Date.now().toString(),
          "X-MB-E2E-Id": uuidv4(),
        },
        timeout: Constants.HTTP_REQUEST_TIMEOUT_MS,
      });
      resp = {
        errorCode: EErrorCode.NONE,
        data: response.data,
      };
    } catch (err: any) {
      resp = {
        errorCode: EErrorCode.HTTP_REQUEST_FAIL,
        errorMessage: err.message,
      };
    }

    return resp;
  }

  public static async get(subUrl: string) {
    var resp: IResponse;

    try {
      var baseURL;
      if (process.env.NODE_ENV === "development") {
        //baseURL = "https://localhost/";
      }

      const response = await axios.get(subUrl, {
        baseURL: baseURL,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        timeout: Constants.HTTP_REQUEST_TIMEOUT_MS,
      });
      resp = {
        errorCode: EErrorCode.NONE,
        data: response.data,
      };
    } catch (err: any) {
      resp = {
        errorCode: EErrorCode.HTTP_REQUEST_FAIL,
        errorMessage: err.message,
      };
    }

    return resp;
  }

  public static async soap(subUrl: string, body: string) {
    var resp: IResponse;

    try {
      var baseURL;
      if (process.env.NODE_ENV === "development") {
        //baseURL = "https://localhost/";
      }

      const response = await axios.post(subUrl, body, {
        baseURL: baseURL,
        method: "POST",
        headers: {
          "Content-Type": "text/xml",
          SOAPAction: "",
        },
        timeout: Constants.HTTP_REQUEST_TIMEOUT_MS,
      });
      resp = {
        errorCode: EErrorCode.NONE,
        data: response.data,
      };
    } catch (err: any) {
      resp = {
        errorCode: EErrorCode.HTTP_REQUEST_FAIL,
        errorMessage: err.message,
      };
    }

    return resp;
  }
}
